import styled from 'styled-components';
import { getSpace, borderClipPath, mq, getTextType } from '../../../stylesheets/tools';

const StyledDateSelect = styled.div`
  .date-select-close-background {
    position: fixed;
    inset: 0;
    z-index: 5;
  }

  .date-select {
    position: relative;
  }

  .date-select__headline {
    margin-bottom: ${getSpace('xxs')};
  }

  .date-select__inner {
    position: relative;
    ${borderClipPath('#000', '#fff')};
    border-radius: 2px;
    color: black;
    width: max-content;
  }

  .date-select__inner::after {
    border-radius: 2px;
  }
  .date-select__button {
    width: 100%;
    display: flex;
    justify-content: space-between;
    ${getTextType('subline')}
    position: relative;
    color: black;
    z-index: 1;
    padding: ${getSpace('xs')} ${getSpace('xl')} ${getSpace('xxs')} ${getSpace('xs')};

    svg {
      position: absolute;
      z-index: 2;
      right: 0;
      bottom: 22px;
      width: 50px;
      display: flex;
      align-items: flex-end;
      justify-content: center;
      pointer-events: none;
    }
  }

  .date-select__popup {
    display: none;
    position: fixed;
    border: 2px solid black;
    border-radius: 3px;
    bottom: 50%;
    left: 50%;
    transform: translate(-50%, 50%);
    width: 90vw;
    z-index: 55;

    ${mq('m')} {
      position: absolute;
      bottom: 0;
      left: 50%;
      max-width: 50vw;
      transform: translate(-50%, calc(100% + ${getSpace('xxs')}));
    }
  }

  .date-select__popup--open {
    display: block;
  }

  .date-select__popup > div {
    margin-top: 0;
  }
`;

export default StyledDateSelect;
